import { Lock } from 'lucide-react';
import { ROUTES } from '@/lib/constants/routes';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { LinkStatusCard } from '@/components/common/LinkStatusCard';

/**
 * "Access denied" - `ProtectedRoute`'s `allowedRoles`/`requiredPermission`
 * fallback (US-039 AC3). Composes the shared `LinkStatusCard` (same card/
 * icon/heading/body/CTA shape as the invite-, shared-profile-expired, and
 * work-email-gate screens) instead of the older bare `AccessDenied` box, so
 * every full-page block screen in the app looks the same.
 *
 * Mounted in two places with different available height: under `AppLayout`
 * for the role/permission gates on the workspace routes, and - from the admin
 * console's guard, which sits ABOVE the shell - in place of the whole page.
 * `fullScreen` handles both without being told which: it subtracts the
 * `--app-chrome-offset` the surrounding layout declared (the navbar's height
 * inside the shell, `0px` outside it).
 */
export function AccessDeniedState() {
  const S = UI_STRINGS.ACCESS_DENIED;
  return (
    <LinkStatusCard
      icon={<Lock size={32} />}
      heading={S.TITLE}
      body={S.DESCRIPTION}
      ctaLabel={S.ACTION}
      ctaTo={ROUTES.DASHBOARD}
      fullScreen
    />
  );
}
